const TextBlockSubHeader = ({ headingStyle, heading }: { heading: string, headingStyle: string }): JSX.Element => {
    const headingClasses = headingStyle === "cookie" ? "text-xl text-neutral-600 font-bold pb-5" : "";
    return <h2 className={headingClasses}>{heading}</h2>
}

export default TextBlockSubHeader;
